var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstAid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ef3731;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #36bfbf;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 24,
    height: 24,
    rx: 3.05,
    ry: 3.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.43,8.74H7.78c-.86,0-1.56.7-1.56,1.56v6.21c0,.86.7,1.56,1.56,1.56h9.65c.86,0,1.56-.7,1.56-1.56v-6.21c0-.86-.7-1.56-1.56-1.56ZM15.25,14.18c0,.15-.12.26-.26.26h-1.35v1.35c0,.15-.12.26-.26.26h-1.55c-.15,0-.26-.12-.26-.26v-1.35h-1.35c-.15,0-.26-.12-.26-.26v-1.55c0-.15.12-.26.26-.26h1.35v-1.35c0-.15.12-.26.26-.26h1.55c.15,0,.26.12.26.26v1.35h1.35c.15,0,.26.12.26.26v1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.14,8.52h-.88l-.64-1.62c-.09-.23-.31-.38-.56-.38h-2.91c-.24,0-.47.15-.56.38l-.64,1.62h-.88l.75-1.92c.21-.54.74-.9,1.32-.9h2.91c.58,0,1.11.36,1.32.9l.75,1.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.25,12.63v1.55c0,.14-.12.26-.26.26h-1.35v1.35c0,.14-.12.26-.26.26h-1.55c-.14,0-.26-.12-.26-.26v-1.35h-1.35c-.14,0-.26-.12-.26-.26v-1.55c0-.14.12-.26.26-.26h1.35v-1.35c0-.14.12-.26.26-.26h1.55c.14,0,.26.12.26.26v1.35h1.35c.14,0,.26.12.26.26Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstAid);
export default __webpack_public_path__ + "static/media/firstAid.4a06782c8ed00e9d8526d02e85d469fd.svg";
export { ForwardRef as ReactComponent };